<template>
  <side-bar
    class="appointment-side-bar no-print"
    v-bind:value="isCollapsed"
    v-on:input="$emit('collapse', $event)">
    <date-picker
      v-bind:today="$options.today"
      v-bind:range="range"
      v-model="date" />
    <div class="appointment-side-bar__content">
      <div class="appointment-side-bar__row">
        <button
          class="appointment-side-bar__row__button"
          v-bind:class="{ select: isTodaySelected }"
          type="button"
          v-on:click="onSelectToday">
          Сегодня
        </button>
        <button
          class="appointment-side-bar__row__button"
          v-bind:class="{ select: isTomorrowSelected }"
          type="button"
          v-on:click="onSelectTomorrow">
          Завтра
        </button>
      </div>
      <div class="appointment-side-bar__row">
        <button
          class="appointment-side-bar__row__button"
          type="button"
          v-bind:class="{ select: period === $options.periodDay }"
          v-on:click="onSelectAppointmentPeriod($options.periodDay)">День</button>
        <button
          class="appointment-side-bar__row__button"
          type="button"
          v-bind:class="{ select: period === $options.periodWeek }"
          v-on:click="onSelectAppointmentPeriod($options.periodWeek)">Неделя</button>
      </div>
      <div
        class="appointment-side-bar__categories"
        ref="categories"
      >
        <button
          class="appointment-side-bar__categories__item"
          type="button"
          v-bind:class="{ select: category === $options.categoryEmployees }"
          v-on:click="onSelectAppointmentCategory($options.categoryEmployees)"
        >Сотрудники</button>
        <button
          class="appointment-side-bar__categories__item"
          type="button"
          v-bind:class="{ select: category === $options.categoryCabinets }"
          v-on:click="onSelectAppointmentCategory($options.categoryCabinets)"
        >Кресла</button>
        <span
          class="appointment-side-bar__categories__line"
          ref="underLine" />
      </div>
      <v-autocomplete
        v-if="category === $options.categoryEmployees"
        class="appointment-side-bar__select"
        hide-details="auto"
        item-text="text"
        item-value="id"
        v-bind:items="employees"
        v-bind:search-input.sync="searchEmployeeQuery"
        v-model="selectedEmployeeId"
        v-on:click="searchEmployeeQuery = ''">
        <template v-slot:item="{ item }">
          <item-employee v-bind:name="item.name" v-bind:positions="item.positions" />
        </template>
        <template v-slot:no-data>
          <p style="padding: 10px; margin:0;">Результатов нет</p>
        </template>
      </v-autocomplete>
      <section
        class="appointment-side-bar__cabinets"
        v-if="category === $options.categoryCabinets">
        <p>Кресла</p>
        <div class="appointment-side-bar__cabinet-list">
          <input-checkbox
            class="appointment-side-bar__cabinet-list__item"
            v-for="({ color, id, name }, index) in cabinetList"
            v-bind:key="id"
            v-bind:style="{ 'background-color': color }"
            v-bind:title="name"
            v-bind:value="selectedCabinets[index]"
            v-on:input="onSelectCabinet(index, $event)" />
        </div>
      </section>
      <div>
        <button
          class="appointment-side-bar__free-doctor"
          type="button"
          v-on:click="dispatchShowFreeDoctor">
          Свободный врач
        </button>
      </div>
      <available-section section="work-time-accounting">
        <button
          class="appointment-side-bar__work-time-controls"
          type="button"
          v-on:click="onOpenWorkTimeControls"
        >Учет времени</button>
      </available-section>
      <aggregator-list
        v-bind:orders-by-aggregators="ordersByAggregators"
        v-on:open-aggregator-orders="onOpenAggregatorOrders"
      />
      <appointment-booking-widget-list
        v-bind:orders="ordersByWidgets"
        v-on:open-orders="onOpenWidgetOrders"
      />
      <button
        class="appointment-side-bar__waiting-list"
        type="button"
        v-on:click="dispatchShowWaitingList">
        Лист ожидания&nbsp;
        <span
          class="appointment-side-bar__counter"
          v-bind:class="{ color: waitingListCount === 0 }"
        >
          ({{ waitingListCount }})
        </span>
      </button>
      <button
        v-if="shownNearestUnconfirmedAppointments"
        class="appointment-side-bar__nearest-unconfirmed-appointment-list"
        type="button"
        v-on:click="onOpenNearestUnconfirmedAppointmentList"
      >
        Обзвон пациентов&nbsp;
        <span
          class="appointment-side-bar__counter"
          v-bind:class="{ color: nearestUnconfirmedAppointmentCount === 0 }"
        >
          ({{ nearestUnconfirmedAppointmentCount }})
        </span>
      </button>
      <template v-if="false">
        <div
          class="appointment-side-bar__column appointment-side-bar__near"
          v-if="isShowNearBlock">
          <div
            class="appointment-side-bar__near__title"
            v-if="appointmentNearList.length === 0">{{ nearEmpty }}</div>
          <div
            class="appointment-side-bar__near__title"
            v-else>{{ nearTitle }}</div>
          <button
            class="appointment-side-bar__near__item"
            type="button"
            v-bind:key="appointment.id"
            v-for="appointment in appointmentNearList"
            v-on:click="openNearAppointment(appointment)"
          >
            <span v-if="period !== $options.periodDay">{{ appointment.date_title }}</span>
            {{ appointment.interval }} {{ appointment.patient_name }}
          </button>
        </div>
      </template>
    </div>
  </side-bar>
</template>

<script>
import AggregatorList from '@/components/AggregatorList.vue';
import AppointmentBookingWidgetList from '@/components/AppointmentBookingWidgetList.vue';
import AvailableSection from '@/views/ClinicPanel/AvailableSection.vue';
import DatePicker from '@/components/DatePicker.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import ItemEmployee from '@/components/ItemEmployee.vue';
import SideBar from '@/components/SideBar.vue';
import appointmentScheduleMixin from '@/mixins/appointmentScheduleMixin';
import dateMixin from '@/mixins/dateMixin';
import {
  GOAL_CLICK_BUTTON_FREE_DOCTOR,
  GOAL_CLICK_NEAREST_UNCONFIRMED_APPOINTMENT,
  GOAL_CLICK_TODAY,
  GOAL_CLICK_TOMORROW,
} from '@/plugins/metric';

export default {
  components: {
    AggregatorList,
    AppointmentBookingWidgetList,
    AvailableSection,
    DatePicker,
    InputCheckbox,
    ItemEmployee,
    SideBar,
  },
  computed: {
    shownNearestUnconfirmedAppointments() {
      return this.nearestUnconfirmedAppointmentCount > 0;
    },
    isShowNearBlock({
      range, formatDateToISO, isAllEmployees, isoDate, period,
    }) {
      if (period === this.$options.periodMonth) {
        const now = new Date();
        return now < range.to;
      }
      if (isAllEmployees || period === this.$options.periodDay) {
        return formatDateToISO(new Date()) <= isoDate;
      }
      const now = new Date();
      return now < range.to;
    },
    /**
     * @arg {{cabinetList:Cabinet[], selectedCabinetIds:number[]}}
     * @returns {boolean[]}
     */
    selectedCabinets: ({ cabinetList, selectedCabinetIds }) => cabinetList
      .map((cabinet) => selectedCabinetIds.includes(cabinet.id)),
    /**
     * @description Сотрудники.
     * @type {any[]}
     */
    employees({ employeeList, $options }) {
      const allEmployees = {
        id: $options.allEmployeesValue,
        text: 'Все сотрудники',
        name: 'Все сотрудники',
      };
      const list = employeeList;
      const hasPermission = this
        .$store
        .getters
        .getAvailableSections
        .includes('view-someone-else-schedule');
      if (this.period !== 'week' && hasPermission) {
        list.unshift(allEmployees);
      }
      if (this.selectedEmployee?.id) {
        list.push({
          id: this.selectedEmployee.id,
          name: this.selectedEmployee.name,
          positions: this.selectedEmployee.positions,
          text: `${this.selectedEmployee.name} ${this.selectedEmployee.positions}`,
        });
      }
      return list;
    },
    /**
     * @description Текст если ближайших визитов нет.
     * @param {string} period
     * @param {string} isoDate
     * @param {string} formatDateToISO
     * @returns {string}
     */
    nearEmpty({ period, isoDate, formatDateToISO }) {
      if (period === this.$options.periodWeek) {
        return 'На неделю визитов нет';
      }
      if (isoDate === formatDateToISO(new Date())) {
        return 'Ближайших визитов нет';
      }
      return 'На данный день визитов нет';
    },
    /**
     * @description Заголовок раздела ближайших визитов.
     * @param period
     * @returns {string}
     */
    nearTitle({ period }) {
      if (period === this.$options.periodWeek) {
        return 'Ближайшие визиты на неделю:';
      }
      return 'Ближайшие визиты:';
    },
    /**
     * @description Выбран режим день
     * @returns {boolean}
     */
    isDayPeriod() {
      return this.period === this.$options.periodDay;
    },
    /**
     * @description Выбран сегодняшний день.
     * @returns {boolean}
     */
    isTodaySelected() {
      return (
        this.isoDate === this.formatDateToISO(this.$options.today)
        && this.isDayPeriod
      );
    },
    /**
     * @description Выбран завтрашний день.
     * @returns {boolean}
     */
    isTomorrowSelected() {
      const tomorrow = new Date(this.$options.today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return (
        this.isoDate === this.formatDateToISO(tomorrow)
        && this.isDayPeriod
      );
    },
    waitingListNotEmpty() {
      return this.waitingListCount > 0;
    },
  },
  data() {
    return {
      isShowTooltipMonth: false,
      searchEmployeeQuery: '',
      selectedCabinetIds: this.initialCabinetsIds,
    };
  },
  mounted() {
    const index = this.category === this.$options.categoryEmployees ? 0 : 1;
    if (this.prevCategory === '' || this.category === this.prevCategory) {
      this.animate(index);
    } else {
      const startIndex = this.prevCategory === this.$options.categoryCabinets ? 1 : 0;
      this.animate(startIndex);
      this.animate(index);
    }
  },
  methods: {
    /**
     * @description Анимировать переход.
     * @param {number} index Индекс категории.
     * @returns {void}
     */
    animate(index) {
      const container = this.$refs.categories.getBoundingClientRect();
      const tab = this.$refs.categories.childNodes[index].getBoundingClientRect();
      this.$refs.underLine.style.left = `${tab.left - container.left}px`;
      this.$refs.underLine.style.width = `${tab.width}px`;
    },
    /**
     * @description Отправить событие открытия листа ожидания на день.
     * @returns {void}
     */
    dispatchShowWaitingList() {
      this.$emit('open-waiting-list');
    },
    /**
     * @description Отправить событие открытия листа свободных докторов.
     * @returns {void}
     */
    dispatchShowFreeDoctor() {
      this.$goal(GOAL_CLICK_BUTTON_FREE_DOCTOR);
      this.$emit('open-free-doctor');
    },
    /**
     * @description Обработать открытие заявок от агрегатора.
     * @param {object} aggregator
     * @returns {void}
     */
    onOpenAggregatorOrders(aggregator) {
      this.$emit('open-aggregator-orders', aggregator);
    },
    /**
     * @description Обработать открытие заявок полученных через виджет онлайн-записи.
     * @param {object} widget
     * @returns {void}
     */
    onOpenWidgetOrders(widget) {
      this.$emit('open-widget-orders', widget);
    },
    /**
     * @description Обработать открытие листа ближайших неподтвержденных записей.
     * @returns {void}
     */
    onOpenNearestUnconfirmedAppointmentList() {
      this.$emit('open-nearest-unconfirmed-appointment-list');
      this.reachGoal();
    },
    /**
     * @description Достичь цели
     * @returns {void}
     */
    reachGoal() {
      this.$goal(GOAL_CLICK_NEAREST_UNCONFIRMED_APPOINTMENT);
    },
    /**
     * @description Обработать открытия учета рабочего времени.
     * @returns {void}
     */
    onOpenWorkTimeControls() {
      this.$emit('open-work-time-controls');
    },
    /**
     * @description Обработать выбор категории расписания.
     * @param {string} category
     * @returns {void}
     */
    onSelectAppointmentCategory(category) {
      this.category = category;
    },
    /**
     * @description Обработать выбор периода построения расписания.
     * @param {string} period
     * @returns {void}
     */
    onSelectAppointmentPeriod(period) {
      this.period = period;
    },
    /**
     * @description Обработать выбор на сегодняшний день
     * @returns {void}
     */
    onSelectToday() {
      this.reachClickTodayGoal();
      if (this.isTodaySelected) {
        return;
      }
      this.period = this.$options.periodDay;
      this.date = new Date();
    },
    /**
     * @description Обработать выбор на завтрашний день
     * @returns {void}
     */
    onSelectTomorrow() {
      this.reachClickTomorrowGoal();
      const tomorrow = new Date(this.$options.today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (this.isTomorrowSelected) {
        return;
      }
      this.period = this.$options.periodDay;
      this.date = tomorrow;
    },
    /**
     * @description Достичь цели клика по кнопке "Сегодня".
     * @returns {void}
     */
    reachClickTodayGoal() {
      this.$goal(GOAL_CLICK_TODAY);
    },
    /**
     * @description Достичь цели клика по кнопке "Завтра".
     * @returns {void}
     */
    reachClickTomorrowGoal() {
      this.$goal(GOAL_CLICK_TOMORROW);
    },
    /**
     * @description Обработать выбор кабинета.
     * @param {number}  index
     * @param {boolean} value
     * @returns {void}
     */
    onSelectCabinet(index, value) {
      const cabinetId = this.cabinetList[index].id;
      if (value === true) {
        this.selectedCabinetIds.push(cabinetId);
      } else {
        this.selectedCabinetIds = this.selectedCabinetIds.filter((id) => id !== cabinetId);
      }
      if (this.period !== this.$options.periodDay && value) {
        this.selectedCabinetIds = [cabinetId];
      }
    },
    /**
     * @description Послать событие открытия ближайшего визита.
     * @param {any} appointment Запись на прием.
     * @returns {void}
     */
    openNearAppointment(appointment) {
      this.$emit('open-near-appointment', appointment);
    },
  },
  mixins: [
    appointmentScheduleMixin,
    dateMixin,
  ],
  props: {
    /**
     * @description Свернут.
     * @type {boolean}
     */
    isCollapsed: { type: Boolean, default: () => false },
    /**
     * @description Список ближайших записей на прием.
     * @type {any[]}
     */
    appointmentNearList: { type: Array, default: () => [] },
    /**
     * @description Список идентификаторов выбранных кабинетов.
     * @type {number[]}
     */
    initialCabinetsIds: { type: Array, default: () => [] },
    /**
     * @description Выбранный сотрудник.
     * @type {Object}
     */
    selectedEmployee: { default: () => null, type: Object },
    /**
     * @description Заявки записи на прием от мед. агрегаторов.
     * @type {any[]}
     */
    ordersByAggregators: { type: Array, required: true },
    /**
     * @description Заявки записи на прием через виджет онлайн-записи.
     * @type {any[]}
     */
    ordersByWidgets: { type: Array, required: true },
    /**
     * @description Количество записей в листе ожидания.
     * @type {number}
     */
    waitingListCount: { type: Number, required: true },
    /**
     * @description Количество ближайших неподтвержденных записей.
     */
    nearestUnconfirmedAppointmentCount: { required: true, type: Number },
  },
  /**
   * @description Текущее время.
   * @type {Date}
   */
  today: new Date(),
  watch: {
    viewQuery(value) {
      this.openAppointmentSchedule(value);
    },
  },
};
</script>

<style lang="scss">
.v-text-field input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.appointment-side-bar {
  &__content {
    padding: 0 12px 60px 12px;
  }
  &__waiting-list,
  &__free-doctor,
  &__nearest-unconfirmed-appointment-list,
  &__work-time-controls {
    display: flex;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 14px !important;
    cursor: pointer;
    margin: 10px 0 !important;
    color: #0489e0;
    border-bottom: 1px solid rgba(4, 137, 224, .3);
    &:hover {
      border-bottom: 1px solid transparent;
    }
  }
  &__row {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    gap: 2px;
    .appointment-side-bar__row__button {
      border-radius: 0;
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
    &.indent {
      margin: 0 0 40px 0;
    }
    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Lato', sans-serif;
      border-radius: 4px;
      font-size: 12px;
      height: 30px;
      width: 100%;
      background-color: #EAEFF3;
      color: #192A3E;
      &.select,
      &:hover {
        background-color: #357ebd;
        color: #FFFFFF;
      }
      &.disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
  &__categories {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 30px;
    position: relative;
    text-align: center;
    &__item {
      color: var(--reading-color);
      cursor: pointer;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      padding-bottom: 8px;
      border-bottom: 1px solid #707683;
      &.select,
      &:hover {
        color: var(--action-color);
      }
    }
    &__line {
      background: #0489e0;
      height: 2px;
      position: absolute;
      bottom: -1.5px;
      transition-duration: var(--animate-duration);
      transition-property: all;
    }
  }
  &__select {
    font-size: 12px;
    font-weight: 500;
    margin: 0 0 50px 0;
    cursor: pointer;
  }
  &__column {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__near {
    margin-top: 50px;
    &__title {
      font-weight: 700;
      font-size: 16px;
      line-height: 19.2px;
    }
    &__item {
      text-align: left;
      font-weight: 600;
      font-size: 14px !important;
      line-height: 16.8px !important;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      color: var(--action-color);
      cursor: pointer;
      max-width: 90%;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__cabinets {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #c2cfe0;
    margin: 18px 0 40px 0;
    padding: 10px 8px;
    p {
      display: flex;
      color: #707683;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin-bottom: 11px !important;
    }
  }
  &__cabinet-list {
    display: grid;
    column-gap: 8px;
    grid-template-columns: 1fr;
    row-gap: 9px;
    overflow-y: auto;
    max-height: 290px;
    &__item {
      background: #d2edb0;
      border-radius: 4px;
      padding: 5px;
      line-height: 0.8;
      display: flex;
      align-content: center;
      span {
        font-size: 12px !important;
        line-height: 14px !important;
        &:before {
          margin: 0 5px 0 0 !important;
        }
      }
    }
  }
  &__input {
    margin: 10px 0 0 0;
    width: 100%;
    background-color: #ffffff;
    background-image: url("@/assets/img/checked/checked-grey.svg");
    background-position: right 17px center;
    border: 1px solid #c2cfe0;
    border-radius: 4px;
    outline: none;
    height: 40px;
    padding: 0 10px;
    appearance: none;
    font-size: 16px;
    color: #192a3e;
    font-weight: 400;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 2px solid #0489e0;
      outline: 0;
      background-image: url("@/assets/img/checked/checked-grey-top.svg");
    }
    &:disabled {
      background-color: #fff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
    }
  }
  &__counter {
    color: red;
    &.color {
      color: #0489e0;
    }
  }
}
@media screen and (orientation: landscape) and (min-width:480px) and (max-width: 900px) {
  .appointment-side-bar {
    &__content {
      padding-bottom: 30px;
    }
  }
}
@media print {
  .appointment-side-bar.no-print {
    display: none;
  }
}
@media screen and (max-width: 700px) {
  .appointment-side-bar__near {
    padding: 0 0 50px 0;
    margin-top: 20px;
  }
}
@media screen and (max-width: 480px) {
  .side-bar {
    &__reverse {
      width: 100%;
    }
  }
  .appointment-side-bar {
    &__cabinet {
      &-list {
        grid-template-columns: 1fr;
      }
    }
    &__select {
      font-size: 16px;
    }
    .calendars-container {
      width: 100%;
      .calendar-table th.available {
        max-width: 20px;
        span {
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
